import { Component, EventEmitter, Input, OnInit, Output, forwardRef, ViewChild, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ButtonComponentConfig } from '../../utils/button';
import { CrudFormPreviewerItem, CrudViewFormItemType } from '../../utils/edit-form';
@Component({
  selector: 'rappider-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RappiderDocumentUploadComponent),
      multi: true
    }
  ]
})
export class RappiderDocumentUploadComponent implements ControlValueAccessor {
  @ViewChild('fileInput') fileInput: ElementRef;

  @Input() elementId: string;
  @Input() previewerConfig?: CrudFormPreviewerItem = {
    modalConfig: {
      width: '100%',
      title: 'Preview',
      okText: 'Select'
    },
    buttonConfig: {
      text: '',
      icon: { name: '	far fa-eye' },
      borderSettings: {
        border: '0'
      },
      customColorSettings: {
        backgroundColor: 'var(--section-background-color)',
        color: 'var(--primary-color)'
      },
      shadowSettings: {
        boxShadow: '0 0 0 var(--section-background-color)'
      }
    },
    type: CrudViewFormItemType.Alert
  };

  @Output() fileSelected = new EventEmitter<any>();

  browseFileText = 'Browse File';
  source: any;

  _value: any;

  get value() {
    return this._value;
  }

  set value(value: any) {
    this._value = value;
    this.onChange(value);
    this.onTouched();
    this.fileSelected.emit(value);
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  openFileInput() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file && file?.type?.startsWith('image/png') || file?.type?.startsWith('image/jpeg') || file?.type?.startsWith('image/bmp')) {
      const reader = new FileReader();
      reader.onload = () => {
        const previewImageUrl = reader.result as string;
        this.value = file;
        this.source = previewImageUrl;
      };
      reader.readAsDataURL(file);
    } else if (file && file?.type?.startsWith('application/pdf')) {
      this.value = file;
      this.source = file;
    } else {
      this.value = file;
      this.source = URL.createObjectURL(file);
    }

    if (this.previewerConfig?.buttonConfig) {
      this.previewerConfig.buttonConfig.text = file?.name;
      this.browseFileText = 'Change File';
    }

  }

}
